export default __webpack_public_path__ + "be856053df05db916c07df71fee7f78d.png";